<template>
  <div class="stickers-tools-background">
    <h3 class="stickers-tools-background__title">Select Background Color</h3>
    <StickersToolsColorPicker :value="selectedBgColor" @change="handleChange" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import StickersToolsColorPicker from "components/jiffy/vue-product-details-dtf/Stickers/StickersTools/StickersToolsColorPicker.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { type Sticker } from "../../types";
import { useDtfStore } from "../../store";
import { useStickersStore } from "../../stickers-module";

const props = defineProps<{
  artwork: Sticker.Artwork;
}>();

const store = useDtfStore();
const stickersStore = useStickersStore();
const selectedBgColor = computed(() => props.artwork.bgColor);

const handleChange = (bgColor: string) => {
  store.updateArtworkValuesById({ id: props.artwork.id, bgColor });

  const payload = {
    background_color: bgColor,
    page: "PDP",
    business_line: "Stickers",
    artwork_id: props.artwork.id,
    is_bg_removed: props.artwork.removeBackground
  };

  submitDtfEvent("user_applied_background_color_to_sticker", payload);

  if (!props.artwork.isFile && !props.artwork.isSimulated) {
    stickersStore.generateStickerImage({
      artwork: props.artwork,
      bgColor
    });
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";

.stickers-tools-background {
  &__title {
    margin: 16px 0;
    color: $text-black;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
  }
}
</style>
